
//Address types
export const addressTypes = {
  TEAMS: 'teams',
  SLACK: 'slack',
  SMS: 'sms',
  WHATSAPP: 'sms_whatsapp',
  EMAIL: 'email',
}

//Basic address types subset
export const basicAddressTypes = [
  addressTypes.SMS,
  addressTypes.WHATSAPP,
  addressTypes.EMAIL,
]

//Integration address types subset
export const integrationAddressTypes = [
  addressTypes.TEAMS,
  addressTypes.SLACK,
]

//Address type options array
export const addressTypeOptions = [
  {label: 'Teams', value: addressTypes.TEAMS},
  {label: 'Slack', value: addressTypes.SLACK},
  {label: 'SMS', value: addressTypes.SMS},
  {label: 'WhatsApp', value: addressTypes.WHATSAPP},
  {label: 'Email', value: addressTypes.EMAIL},
]

//Basic address type options array
export const basicAddressTypeOptions = addressTypeOptions
  .filter(option => basicAddressTypes.includes(option.value))
